export class GitRepositoryStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<GitRepositoryStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<GitRepositoryStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GitRepositoryStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
